import { memo, useState, FC } from 'react';
import styles from '@/styles/components/rating.module.scss';
import Image from 'next/image';

type Props = {
  disabled: boolean;
  setRating: (rateNumer: number) => void;
};

type rateItem = {
  active: boolean;
};
const Rating: FC<Props> = memo(props => {
  const { disabled, setRating } = props;
  const [rateList, setRateList] = useState<rateItem[]>([
    { active: false },
    { active: false },
    { active: false },
    { active: false },
    { active: false }
  ]);

  const hoverRate = (e: number) => {
    if (!disabled) {
      const newRateList = [...rateList];
      newRateList.forEach((item, index) => {
        item.active = e >= index;
      });
      setRateList(newRateList);
    }
  };

  const leaveRate = (e: number) => {
    if (!disabled) {
      const newRateList = [...rateList];
      newRateList.forEach(item => (item.active = false));
      setRateList(newRateList);
    }
  };

  const clickRate = (e: number) => {
    hoverRate(e);

    setRating(e + 1);
  };

  return (
    <div className={styles.Rate_Wrapper}>
      {rateList.map((item: any, index: number) => {
        if (item.active === false) {
          return (
            <span
              className={styles.Rate}
              key={index}
              onClick={() => clickRate(index)}
              onMouseEnter={() => hoverRate(index)}
            >
              <Image src="/blog/icon/EmptyStar.svg" alt={'emptyStar'} width={24} height={24} />
            </span>
          );
        } else {
          return (
            <span
              className={styles.Rate}
              key={index}
              onClick={() => clickRate(index)}
              onMouseLeave={() => leaveRate(index)}
            >
              <Image
                src={index === 4 ? '/blog/icon/LastActiveStar.svg' : '/blog/icon/ActiveStar.svg'}
                alt={'activeStar'}
                width={24}
                height={24}
              />
            </span>
          );
        }
      })}
    </div>
  );
});

export default Rating;
